(function () {
  if (!customElements.get("media-banner-video")) {
    class MediaBannerVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector("video");
        if (!this.video || this.visibilityObserver) return;

        this.isVisible = false;
        this.handleVisibility = () => {
          if (this.isVisible && !document.hidden) {
            this.hydrate();
            this.video.play()?.catch(() => {});
          } else {
            this.video.pause();
          }
        };
        document.addEventListener("visibilitychange", this.handleVisibility);

        if (!("IntersectionObserver" in window)) {
          this.isVisible = true;
          this.handleVisibility();
          return;
        }

        this.loadObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.hydrate();
            this.loadObserver.disconnect();
          },
          { rootMargin: "300px 0px" }
        );
        this.loadObserver.observe(this);

        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.isVisible = entries[0].isIntersecting;
          this.handleVisibility();
        });
        this.visibilityObserver.observe(this);
      }

      hydrate() {
        const sources = this.video.querySelectorAll("source[data-src]");
        if (!sources.length) return;

        if (this.video.dataset.poster) {
          this.video.poster = this.video.dataset.poster;
          delete this.video.dataset.poster;
        }
        sources.forEach((source) => {
          source.src = source.dataset.src;
          delete source.dataset.src;
        });
        this.video.preload = "metadata";
        this.video.load();
      }

      disconnectedCallback() {
        this.loadObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.visibilityObserver = null;
        document.removeEventListener("visibilitychange", this.handleVisibility);
        this.video?.pause();
      }
    }

    customElements.define("media-banner-video", MediaBannerVideo);
  }

  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".media-banner__heading");

    if (!text) return;

    ScrollTrigger.create({
      trigger: text,
      start: "50% 95%",
      end: "bottom top",
      onEnter: () => text.classList.add("animated"),
    });
  };

  initAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
  });
})();
